import LanguageList from "../components/LanguageList";
import Navigation from "../components/Navigation";

const Language = () => {
  return (
    <>
      <Navigation title={"LANGUAGE"} appBarColor="orange" />
      <div className="fixed-layout flex flex-col ">
        <div className="language-card my-2 flex-1">
          <LanguageList />
        </div>
      </div>
    </>
  );
};

export default Language;
